import axiosInstance from "@/utils/axiosInstance";

const baseUrl: string = "api/public/connectedBoxes";

const state = {};

const getters = {};

const mutations = {};

const actions = {
    updateBatteryDate({commit}, id: number) {
        return axiosInstance.put(`${baseUrl}/${id}/batteryUpdate`)
        .then((data) => data.data);
    },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
